<template>
  <div class="container">
       <div class="msg-box">
            <div class="left-box">
                <div class="top">
                    <el-carousel arrow="never">
                        <el-carousel-item v-for="(item,index) in carousel" :key="item.id">
                        <div @click="newsDetail(item)" class="carousel-box">
                             <img :src="item.img_url"  style="object-fit: cover;height:72%;width:100%;">
                             <div class="down">
                                <p class="title text-flow">
                                    {{item.title}}
                                </p>
                                <hr/>
                                <span class="sub-title">
                                    {{item.content}}
                                </span>
                            </div>
                        </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
               
            </div>
            <div class="right-box">
                 <div class="up">
                     <img class="icon" src="../assets/img/hotPoint.png">
                     <span class="hot">热点资讯</span>
                 </div>
                 <div class="right-center">
                    <ul>
                        <li class="active-text" v-for="(it,index) in newList" :key="it.id" @click="newsDetail(it)">
                            <span class="text-flow"> {{it.title}} </span>
                            <span class="date"> {{it.create_date}}</span>
                        </li>
                    </ul>
                     <p class="more" @click="changeMore">
                        <img src="../assets/img/changeIcon.png" alt="">
                        &nbsp;换一换&nbsp;
                    </p>
                 </div>
            </div>
       </div>
  </div>
</template>

<script>
export default {
  name: 'JewelsMeaasge',
  components: {},
  props: {
    dataList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
        newList:[],
        carousel:[],
        flag:true

    };
  },
  watch: {
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.newList = this.dataList.slice(0,6);
    this.carousel = this.dataList.slice(0,3);
  },
  updated() {

  },
  methods:{
     newsDetail(item){
      this.$router.push({path: '/articleContent', query: {articleId: item.id}});
    },
    changeMore() {
        this.flag = !this.flag;
        if(this.flag) {
            this.newList = this.dataList.slice(0,6);
        } else {
            this.newList = this.dataList.slice(6);
        }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
    // width: 100%;
    height: 100%;
   .msg-box {
       display: flex;
       justify-content: space-between;
       height: 100%;
       width: 100%;
       .left-box {
          width: 49%;
          height: 100%;
          background: #ffffff;
          border-radius: 14px;
          .top {
            // height: 72%;
            height: 100%;
            .carousel-box {
              cursor: pointer;
              height: 100%;
            }
            .el-carousel{
                height: 100%;
                border-radius: 14px 14px 0 0;
            }
          }
          .down {
             height: 28%;
             padding: 20px;
            .title {
                font-size: 24px;
                font-weight: 700;
            }
            .sub-title {
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
          }
       }
       .right-box {
          width: 49%;
          height: 100%;
          background: #ffffff;
          border-radius: 14px;
          padding: 20px 30px;
          .up {
            display: flex;
            align-items: center;
            .icon {
                // width: 28px;
                // height: 29px;
                display: inline-block;
                // background: rgba(32, 147, 202, 1);
                // border-radius: 50%;
            }
            .hot {
                text-shadow: 0px 2.34px 0px rgba(255, 255, 255, 0.85);
                color: rgba(32, 147, 202, 1);
                font-size: 16px;
                font-weight: 500;
                padding-left: 10px;
            }
          }
          .right-center {
            .active-text {
                color: rgba(26, 26, 26, 1);
                font-weight: 500;
                .text-flow{
                    width: 80%;
                }
            }
            ul {
              min-height: 360px;
            }
             ul li {
                width: 100%;
                height: 60px;
                border-bottom: 1px solid #ccc;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: rgba(114, 113, 113, 1);
                font-size: 18px;
                font-weight: 400;
                cursor: pointer;
                &:last-child {
                    border-bottom: none;
                }
                .content{
                    width: 70%;
                    display: inline-block;
                }
             }
             .more {
                display: flex;
                color: rgba(32, 147, 202, 1);
                font-size: 16px;
                font-weight: 400;
                cursor: pointer;
             }
          }
       }
   }
  
  .top ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
    width: 10px;
    height: 10px;
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 50%;
    opacity: 0.5;
  }  
 .top ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button{
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-radius: 50%;
    opacity: 1;
  }
   .top ::v-deep .el-carousel__container {
        height: 100%!important;
   }
   .top ::v-deep .el-carousel__indicators {
     z-index: 100;
   }
    .top ::v-deep .el-carousel__indicators--horizontal { 
           top: 64%;
    }
}
</style>